import { render, staticRenderFns } from "./JPage.vue?vue&type=template&id=8b163c82&scoped=true"
import script from "./JPage.vue?vue&type=script&lang=js"
export * from "./JPage.vue?vue&type=script&lang=js"
import style0 from "./JPage.vue?vue&type=style&index=0&id=8b163c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b163c82",
  null
  
)

export default component.exports